const LABEL = {
  open: "Anfragen geöffnet",
  limited: "Nur wenige Projektplätze verfügbar",
  closed: "Momentan keine neuen Projekte",
  delayed: "Verlängerte Antwortzeit",
};

const DOT = {
  open: "bg-status-available",
  limited: "bg-status-reserved",
  closed: "bg-status-taken",
  delayed: "bg-signal",
};

export const CapacityNotice = ({ capacity }) => {
  if (!capacity?.visible) return null;
  return (
  <section data-testid="capacity-notice" className="relative border-b border-paper-line bg-paper-subtle/70">
      <div className="ap-container flex flex-col gap-2 py-5 sm:flex-row sm:items-center sm:gap-6">
        <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-ink">
          <span className={`h-2 w-2 ${DOT[capacity.status]}`} aria-hidden="true" />
          {LABEL[capacity.status]}
        </span>
        {capacity.note ? <p className="ap-body text-charcoal">{capacity.note}</p> : null}
      </div>
    </section>
  );
};
